import React from 'react';
import Editor from 'draft-js-plugins-editor';
import {
    EditorState, convertToRaw, RichUtils, convertFromRaw
} from "draft-js";
import {Link} from "react-router-dom";

import createLink from "../../../libs/createLink";

import createMentionPlugin from 'draft-js-mention-plugin';
import createImagePlugin from 'draft-js-image-plugin';
import addLinkPlugin from "./plugins/AddLinkPlugin";
// import createLinkifyPlugin from 'draft-js-linkify-plugin';

import 'draft-js-linkify-plugin/lib/plugin.css';
import "draft-js/dist/Draft.css";
import 'draft-js-emoji-plugin/lib/plugin.css';
import 'draft-js-mention-plugin/lib/plugin.css';
import 'draft-js-image-plugin/lib/plugin.css';


import {getBlockStyle} from "./blockStyles/BlockStyleToolbar";
import {mediaBlockRenderer} from "./entities/mediaBlockRenderer";
import isSoftNewlineEvent from "draft-js/lib/isSoftNewlineEvent";

const primaryColor = 'rgba(95, 170, 253, 1.0)';
const secondaryColor = 'rgba(128, 128, 128, 1.0)';
const successColor = 'rgba(40, 167, 69, 1.0)';
const dangerColor = 'rgba(251, 77, 77, 1.0)';
const warningColor = 'rgba(255, 177, 66, 1.0)';
const infoColor = 'rgba(94, 159, 244, 1.0)';

const colorStyleMap = {
    "color-primary": {
        color: primaryColor,
        fill: primaryColor,
    },
    "color-secondary": {
        color: secondaryColor,
        fill: secondaryColor,
    },
    "color-success": {
        color: successColor,
        fill: successColor,
    },
    "color-danger": {
        color: dangerColor,
        fill: dangerColor,
    },
    "color-warning": {
        color: warningColor,
        fill: warningColor,
    },
    "color-info": {
        color: infoColor,
        fill: infoColor,
    }
};

const imagePlugin = createImagePlugin();
// const linkifyPlugin = createLinkifyPlugin({
//     target: "_blank",
//     rel : "noopener noreferrer nofollow"
// });


class DraftTextareaEditor extends React.Component {
    constructor(props){
        super(props);
        const newEditorState = this.props.defaultValue && this.props.defaultValue.blocks && this.props.defaultValue.blocks[0] ? EditorState.createWithContent(convertFromRaw(this.props.defaultValue)) : EditorState.createEmpty();
        this.state = {
          editorState: newEditorState,
        };

        this.mentionPlugin = createMentionPlugin({
            mentionComponent: (mentionProps) => (
                <Link to={createLink('userProfile', mentionProps.mention)} target={"_blank"} rel="noopener noreferrer" className={"mentionned-name"}>
                    @{mentionProps.mention.username}
                </Link>
            ) ,
            theme : {
                mentionSuggestions : "mentionSuggestions",
                mentionSuggestionsEntry: "mentionSuggestionsEntry",
                mentionSuggestionsEntryFocused: "mentionSuggestionsEntryFocused",
                mentionSuggestionsEntryText: "mentionSuggestionsEntryText",
                mentionSuggestionsEntryAvatar: "mentionSuggestionsEntryAvatar"
            }
        });

        this.onChange = this.onChange.bind(this);
    }

    onChange(editorState) {
        this.setState({editorState}, ()=>this.props.onChange(this.getRaw()));
    };

    getRaw() {
        const content = this.state.editorState.getCurrentContent();
        return convertToRaw(content);
    }

    focus = () => this.refs.editor.focus();

    handleKeyCommand(command) {
        const newState = RichUtils.handleKeyCommand(
            this.state.editorState,
            command
        );
        if (newState) {
            this.onChange(newState);
            return "handled";
        }
        return "not-handled";
    };

    handleReturn(event) {
        if (isSoftNewlineEvent(event)) {
            this.onChange(RichUtils.insertSoftNewline(this.state.editorState));
            return 'handled';
        }
        return 'not-handled';
    }

    updateContent(newContentRaw){
        if(newContentRaw && newContentRaw.blocks && newContentRaw.blocks[0]){
            const contentState =  convertFromRaw(newContentRaw);
            let editorState = EditorState.createWithContent(contentState);
            this.setState({editorState});
        } else {
            let editorState = EditorState.createEmpty();
            this.setState({editorState});
        }
    }

    render(){
        const plugins = [
            imagePlugin,
            addLinkPlugin,
            // linkifyPlugin,
            this.mentionPlugin
        ];
        return(
            <div className={`form-field custom-textarea readonly-editor`}>
                <Editor customStyleMap={colorStyleMap}
                        editorState={this.state.editorState}
                        plugins={plugins}
                        blockRendererFn={mediaBlockRenderer}
                        ref="editor"
                        blockStyleFn={getBlockStyle}
                        placeholder={this.props.placeholder || ""}
                        handleKeyCommand={this.handleKeyCommand.bind(this)}
                        onChange={this.onChange.bind(this)}
                        handleReturn={this.handleReturn.bind(this)}/>
            </div>
        )
    }
}

export default DraftTextareaEditor;